import { apiBaseUrl } from '../apiBaseUrl';

const LEGACY_STORAGE_PREFIX = 'picsect:person-groups:';

function readLegacyPersonGroups(orderId) {
  try {
    const value = localStorage.getItem(`${LEGACY_STORAGE_PREFIX}${orderId}`);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    return null;
  }
}

function removeLegacyPersonGroups(orderId) {
  try {
    localStorage.removeItem(`${LEGACY_STORAGE_PREFIX}${orderId}`);
  } catch (error) {
    // A failed cleanup is harmless; the API remains the source of truth.
  }
}

async function loadPersonGroups(orderId) {
  try {
    const response = await requestPersonGroups(orderId);
    if (!response.ok) throw new Error(`Person groups endpoint returned ${response.status}`);
    const data = await response.json();
    const payload = data?.result || data?.personGroups || data;
    const quota = data?.quota || null;
    if (payload?.groups) return { payload, quota };

    const legacyPayload = readLegacyPersonGroups(orderId);
    if (legacyPayload?.groups) {
      const saved = await savePersonGroups(orderId, legacyPayload);
      removeLegacyPersonGroups(orderId);
      return { payload: legacyPayload, quota: saved?.quota || quota, migrated: true };
    }
    return { payload: null, quota };
  } catch (error) {
    return { payload: null, error };
  }
}

async function consumePersonScan(orderId) {
  const token = localStorage.getItem('token');
  const response = await fetch(`${apiBaseUrl}/user/orders/${encodeURIComponent(orderId)}/ai-person-groups/scan`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data?.error || `Person scan quota endpoint returned ${response.status}`);
    error.status = response.status;
    error.code = data?.code;
    error.quota = data?.quota || null;
    throw error;
  }
  return { quota: data?.quota || null, reservationId: data?.reservationId || null };
}

async function savePersonGroups(orderId, payload, { reservationId } = {}) {
  const response = await requestPersonGroups(orderId, payload, reservationId);
  if (!response.ok) throw new Error(`Person groups endpoint returned ${response.status}`);
  return response.json().catch(() => ({ success: true }));
}

function requestPersonGroups(orderId, payload, reservationId) {
  const token = localStorage.getItem('token');
  return fetch(`${apiBaseUrl}/user/orders/${encodeURIComponent(orderId)}/ai-person-groups`, {
    method: payload ? 'PUT' : 'GET',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(payload ? { 'Content-Type': 'application/json' } : {}),
      ...(reservationId ? { 'X-AI-Person-Scan-Reservation': reservationId } : {}),
    },
    ...(payload ? { body: JSON.stringify(payload) } : {}),
  });
}

export { consumePersonScan, loadPersonGroups, savePersonGroups };
